module.exports = __webpack_public_path__ + "img/igp.f33c78fa.webp";